// extracted by mini-css-extract-plugin
module.exports = {"icone":"styles_icone__3Npod"};